// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"567":"cbd8b4c9","787":"c55e1f37"}[chunkId] + ".chunk.js";
};